/**
 * Photographers & Videographers - All Projects Page
 * Photography and videography sessions management
 */

import { useEffect } from 'react';
import { AllProjectsPage } from '@/components/industry/pages/AllProjectsPage';
import { CompanyType } from '@/types/company';
import { MainLayout } from "@/components/MainLayout";

export default function PhotographersProjectsPage() {
  useEffect(() => {
    document.title = 'Todas as Sessões | Controle Financeiro';
  }, []);

  return (
<MainLayout>
    <div className="container mx-auto py-6">
      <AllProjectsPage
        domain={CompanyType.PHOTOGRAPHERS_VIDEOGRAPHERS}
        title="Todas as Sessões"
        description="Gerencie suas sessões de fotografia e vídeo"
        createButtonLabel="Nova Sessão"
      />
    </div>
  
    </MainLayout>);
}

